<script setup>
import { defineProps, defineEmits, shallowRef } from 'vue';
import defaultAvatar from '@/assets/new-icons/default-avatar.png';

const props = defineProps({
  src: {
    type: String,
    default: '',
  }
});


const emits = defineEmits(['upload']);

const src = shallowRef(props.src ?? defaultAvatar);

function uploadAvatar({ target }) {
  const file = target.files[0];
  if (file) {
    emits('upload', file);
  }
}
</script>
<template>
  <label class="avatar">
    <input type="file" class="avatar-uploader" @change="uploadAvatar">
    <img :src="src" class="avatar-img" alt="аватар">
  </label>
</template>


<style lang="scss" scoped>
.avatar {
  height: 80px;
  width: 80px;
  display: flex;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
  border-radius: 50%;
  cursor: pointer;

  &-uploader {
    margin-top: 0;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    opacity: 0;
    z-index: 2;
    cursor: pointer;
  }

  &-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
  }
}
</style>